/**
 * Modale Bootstrap di modifica di un record dello Storico non trova.
 * La modale viene spostata su body per evitare problemi di z-index/backdrop.
 */
import type { ModalitaRaccolta } from '@/types/entities/raccolta-delega.ts';
import type { OperatoreCombobox } from '../components/operatore-combobox.ts';
import type { ModificaArchivio } from './api/archivio.ts';

export interface RecordDaModificare extends ModificaArchivio {
  nominativo: string;
  operatoreNome: string | null;
}

type SalvaModifica = (dati: ModificaArchivio) => Promise<boolean>;

export class ModaleModificaArchivio {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private modal: any;
  private operatoreOriginale: string | null = null;
  private onSalva: SalvaModifica | null = null;

  constructor(private el: HTMLElement) {
    document.body.appendChild(el);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.modal = new (globalThis as any).bootstrap.Modal(el);
    el.querySelector('form')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.salva();
    });
  }

  apri(record: RecordDaModificare, onSalva: SalvaModifica): void {
    this.onSalva = onSalva;
    this.operatoreOriginale = record.operatore;
    const titolo = this.el.querySelector('[data-modifica-titolo]');
    if (titolo) titolo.textContent = record.nominativo;
    this.campo('modalitaRaccolta').value = record.modalitaRaccolta ?? '';
    this.campo('datapres').value = record.datapres ?? '';
    this.campo('note').value = record.note ?? '';

    // Il combobox conserva la scelta tra un'apertura e l'altra
    const combo = this.combobox();
    combo?.clearSelection();
    const idFenice = Number(record.operatore);
    if (combo && record.operatoreNome && idFenice) combo.preseleziona(idFenice, record.operatoreNome);
    this.modal.show();
  }

  dispose(): void {
    this.modal?.dispose();
    this.el.remove();
  }

  private campo(nome: string): HTMLInputElement {
    return this.el.querySelector(`[data-field="${nome}"]`) as HTMLInputElement;
  }

  private combobox(): OperatoreCombobox | null {
    return this.el.querySelector('wc-operatore-combobox');
  }

  private async salva(): Promise<void> {
    // Combobox vuoto: resta l'operatore del record, che può non essere in anagrafica operatori
    const scelto = this.combobox()?.value ?? null;
    const dati: ModificaArchivio = {
      operatore: scelto !== null ? String(scelto) : this.operatoreOriginale,
      modalitaRaccolta: (this.campo('modalitaRaccolta').value || null) as ModalitaRaccolta | null,
      datapres: this.campo('datapres').value || null,
      note: this.campo('note').value.trim() || null,
    };
    const btn = this.el.querySelector('[data-modifica-salva]') as HTMLButtonElement | null;
    if (btn) btn.disabled = true;
    const ok = await this.onSalva?.(dati);
    if (btn) btn.disabled = false;
    if (ok) this.modal.hide();
  }
}
